import useAppStore from '@/store/app';
import { useEffect } from 'react';

function useTitle(title) {
  const { deploymentTitle } = useAppStore();
  useEffect(() => {
    const newTitle = `${title ? `${title} | ` : ''}${deploymentTitle ? deploymentTitle : 'Codemeta GmbH'}`;
    document.title = newTitle;
    return () => {
      document.title = newTitle;
    };
  }, [title]);
}

export default useTitle;
